import React, { useState, useEffect } from "react";

const Intent = (props) => {
    const { data } = props;
    const [selectedEntities, setSelectedEntities] = useState({});
    const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);
    // const [selectedEntity, setSelectedEntity] = useState(null);
    const [selectedEntity, setSelectedEntity] = useState([]);

    useEffect(() => {
        if (data?.choices?.length === 1) {
            const choice = data.choices[0];
            // Automatically perform the onClick logic
            localStorage.setItem(
                "inputValue1",
                JSON.stringify({ key1: choice?.intent })
            );
            // props?.setErrors((prevErrors) => {
            //     const updatedErrors = {
            //       ...prevErrors,
            //       [props?.index]: { key1: choice?.intent, displayName: choice?.intent },
            //     };
            //     console.log("🔄 Updated Errors inside useEffect:", updatedErrors);
            //     return updatedErrors;
            //   });
            setSelectedEntities(choice?.entities); // Set selected entities
            setSelectedButtonIndex(0); // Track selected intent
            // If entities are empty, set key1 to an empty string
            if (Object.keys(choice?.entities).length === 0) {
                localStorage.setItem("inputValue", JSON.stringify({ key1: '' }));
            }
        }
    }, [data?.choices?.length]);

    useEffect(() => {
        const entityTypes = Object.keys(selectedEntities);
        if (entityTypes.length === 1) {
            const entityType = entityTypes[0];
            const entities = selectedEntities[entityType];

            if (entities?.length === 1) {
                const singleEntity = entities[0];
                // Automatically perform the onClick logic for the single entity
                setSelectedEntity(singleEntity); // Track selected entity
                localStorage.setItem(
                    "inputValue",
                    JSON.stringify({ key1: singleEntity })
                );
            }
        }
    }, [selectedEntities]);

    return (
        <div>
            <div style={{ padding: "8px" }} className="header-prob">
                {data?.response?.intent}
            </div>
            {/* Render intent buttons */}
            <div className="a1-wrap" style={{ width: "fit-content", margin: '6px', cursor: 'pointer', display: 'flex' }}>
                {data?.choices.map((choice, index) => (
                    <div key={index}>
                        <button
                            className={selectedButtonIndex === index ? 'chat-label-select action-tab' : 'chat-label action-tab'}
                            onClick={() => {
                                localStorage.setItem(
                                    "inputValue1",
                                    JSON.stringify({ key1: choice?.intent })
                                );
                                setSelectedEntities(choice?.entities); // Set selected entities
                                setSelectedButtonIndex(index); // Track selected intent
                                // If entities are empty, set key1 to an empty string
                                if (Object.keys(choice?.entities).length === 0) {
                                    localStorage.setItem("inputValue", JSON.stringify({ key1: '' }));
                                }
                            }}
                        >
                            {choice?.intent.replace(/_/g, " ")}
                        </button>
                        {choice?.sub_intent && (
                            <div
                                style={{
                                background: "#a9f4a9",
                                padding: "10px",
                                marginTop: "10px",
                                fontSize: "12px",
                                fontWeight: "bold",
                                border :'1px solid #dedddd',
                                borderRadius : '8px'
                                }}
                            >
                                <div style={{ fontWeight: "bold", color: "#333" }}>Sub Intent:</div>
                                <div style={{ marginTop: "4px" }}>{choice?.sub_intent.replace(/_/g, " ")}</div>
                            </div>
                            )}



                    </div>
                ))}
            </div>
            {Object.keys(selectedEntities).length > 0 &&    <div style={{ padding: "8px" }} className="header-prob">{data?.response?.entity}</div>}
            {/* Render entities grouped by type */}
            {Object.keys(selectedEntities).length > 0 && (
                <div style={{ marginTop: '10px' }}>
                    {Object.entries(selectedEntities).map(([entityType, values]) => (
                        <div style={{ marginBottom: '16px' }} key={entityType}>  
                            <div style={{ marginLeft: "11px" , fontWeight :"100"}}className="header-prob">{entityType}</div>
                            <ul style={{ margin: 'auto' }}>
                                {values?.map((entity, index) => (
                                    <li key={index}>
                                        <button
                                            className={selectedEntity.includes(entity)? 'option-button clicked' : 'option-button'}
                                            style={{ borderRadius: '10px', margin: '5px', width: 'auto' }}
                                            onClick={() => {
                                                setSelectedEntity((prev) => {
                                                    const isAlreadySelected = prev?.includes(entity);
                                                    const updated = isAlreadySelected
                                                        ? prev?.filter((item) => item !== entity)
                                                        : [...prev, entity];
                                                    
                                                    localStorage.setItem(
                                                        "inputValue",
                                                        JSON.stringify({ key1: updated })
                                                    );
                                                    // props?.setErrors((prevErrors) => {
                                                    //     const updatedErrors = {
                                                    //       ...prevErrors,
                                                    //       [props?.index]: { key1: updated, displayName: updated },
                                                    //     };
                                                    //     console.log("🔄 Updated Errors inside useEffect:", updatedErrors);
                                                    //     return updatedErrors;
                                                    //   });
                                            
                                                    return updated;
                                                });
                                            }}
                                        >
                                            {entity}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Intent;
